  <button
    (click)="onButtonClick($event)"
    dbltap
    (dblClicked)="onButtonDoubleClick($event)"
    (dblTapped)="onButtonDoubleClick($event)"
    [class.active]="active()">
    @if (icon(); as icon) {
      <app-svg-icon [type]="icon" size="largest"/>
    }
    @if (imageUrl(); as imageUrl) {
      <img [alt]="text()" [src]="imageUrl"/>
    }
    <span class="break-word w-100">{{ text() }}</span>
  </button>
